import React from 'react';
import { CtaButton } from './CtaButton';
import { coaches } from '../data/coaches';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';
const chips = ['6 Volumes', '5 Bonuses', '365-Day Calendar', 'EMOM · AMRAP · Tabata', 'Mixed-level scaling'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it and coach from it'];

/**
 * Proof line under the CTA. Swap for a real rating + buyer count
 * (e.g. "4.9/5 from 1,200+ coaches") once you have verified reviews.
 */
const PROOF_LINE = <>
    Built for <span className="font-bold text-white" data-id="element-112" data-mp="x8jo5qqjiyjb">independent bootcamp &amp; group fitness coaches</span>{' '}
    in the US, UK &amp; Australia
  </>;
export function Hero() {
  return <section className="w-full bg-navy-deep" data-id="element-113" data-mp="nbyir4alzley">
      <div className="mx-auto w-full max-w-6xl px-4 pb-12 pt-5 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-10" data-id="element-114" data-mp="3d21t5zvq8oos">
        <div className="grid gap-7 lg:grid-cols-[1.02fr_.98fr] lg:items-center lg:gap-14" data-id="element-115" data-mp="381xlmzcsr4ap">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-116" data-mp="3j7zf9iqmlsgo">
            <p className="text-[10px] font-bold uppercase tracking-[1.6px] text-gold sm:text-[11px]" data-id="element-117" data-mp="3j6fy7px5bddu">
              The 0-decision system for bootcamp coaches
            </p>
            <h1 className="mt-2.5 font-display text-[34px] font-bold uppercase leading-[.94] tracking-tight text-white sm:text-5xl lg:text-6xl xl:text-7xl" data-id="element-118" data-mp="399jnrenosh6n">
              Your next bootcamp class is{' '}
              <span className="text-gold" data-id="element-119" data-mp="30gge7hg5woha">already decided.</span>
            </h1>
          </div>

          <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-120" data-mp="35aau09sncjb3">
            <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} width={1200} height={886} className="mx-auto w-full max-w-[560px] lg:max-w-none" data-id="element-121" data-mp="2qkwmz8cjmdyv" />
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-122" data-mp="2hlj9m4lat58v">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-base lg:text-lg" data-id="element-123" data-mp="2ljgz78izdtcs">
              A six-volume programming system: a 365-day session calendar,
              metabolic and strength blocks, instant swaps for rain, crowds and
              missing gear, coaching scripts and a retention toolkit. Not another
              library to choose from — the session itself, already picked.
            </p>

            <ul className="mt-5 flex flex-wrap gap-1.5 sm:gap-2" data-id="element-124" data-mp="db2erf7rsfn9">
              {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white/70 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-125" data-mp="1ayjg9az6xa4o">
                  {chip}
                </li>)}
            </ul>

            <div className="mt-7 w-full max-w-md lg:mx-0" data-id="element-126" data-mp="3lsp2pbkjgfdd">
              <CtaButton data-id="element-127" data-mp="3lu9y13eog2ca">Get Bootcamp Ready</CtaButton>
            </div>

            <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-128" data-mp="3hqalsx0fjpoq">
              <ul className="flex -space-x-2.5" data-id="element-129" data-mp="1xacgb5dntnua">
                {coaches.map((coach, i) => <li key={`${coach.name}-${i}`} data-id="element-130" data-mp="21by07aom32dz" data-mpi={i}>
                    <img src={coach.avatar} alt={coach.name} width={40} height={40} loading="lazy" className="h-9 w-9 rounded-full border-2 border-navy-deep object-cover sm:h-10 sm:w-10" data-id="element-131" data-mp="218jvvwwe0j3w" />
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/65" data-id="element-132" data-mp="2l0q9iz7zdsqg">
                {PROOF_LINE}
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/60 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-133" data-mp="2tztw4d6cwq9p">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-134" data-mp="uoaivme0svu8">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-135" data-mp="zmlspx4bf6cg" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}